// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main stylesheet with theme system
 */

@property --bg-primary {
  syntax: '<color>';
  initial-value: #d4d0cc;
  inherits: true;
}

@property --bg-secondary {
  syntax: '<color>';
  initial-value: #585450;
  inherits: true;
}

@property --bg-gradient-end {
  syntax: '<color>';
  initial-value: #b8a080;
  inherits: true;
}

@property --color-primary {
  syntax: '<color>';
  initial-value: #006080;
  inherits: true;
}

@property --color-secondary {
  syntax: '<color>';
  initial-value: #00a0c0;
  inherits: true;
}

@property --color-accent {
  syntax: '<color>';
  initial-value: #c88040;
  inherits: true;
}

@property --text-primary {
  syntax: '<color>';
  initial-value: #383430;
  inherits: true;
}

@property --text-secondary {
  syntax: '<color>';
  initial-value: #585450;
  inherits: true;
}

@property --border-color {
  syntax: '<color>';
  initial-value: #f8ffff;
  inherits: true;
}

@property --detail-bg {
  syntax: '<color>';
  initial-value: rgba(255, 255, 255, 0.15);
  inherits: true;
}

:root {
  /* Color properties are set dynamically by ThemeManager — see src/theme.ts.
     @property declarations above provide initial (light-theme) fallbacks
     and enable CSS transitions on custom properties. */

  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;

  /* Timing */
  --transition-easing: cubic-bezier(0.65, 0, 0.35, 1);

  /* Transitions */
  --transition-fast: 700ms var(--transition-easing);
  --transition-normal: 700ms var(--transition-easing);
  --transition-slow: 700ms var(--transition-easing);
  --transition-hover: 350ms var(--transition-easing);
  --transition-linear: 350ms linear;

  /* Border radius */
  --radius-sm: 0.25rem;
  --radius-md: 0.5rem;
  --radius-lg: 1rem;
  --radius-full: 9999px;

  /* Layout */
  --sidebar-width: 260px;
  --breakpoint-sidebar: 900px;
  --pill-button-height: 4.5rem;
  --floating-toggle-size: 4.5rem;
  --floating-toggle-icon-size: 2.0625rem;
  --page-bottom-buffer: clamp(3rem, 5vh, 6rem);

  /* Gallery tile accent gradients — composed from theme colors so they
     update automatically on theme change, matching the mockup's gradient
     accent tiles. */
  --tile-grad-1: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);
  /* Mockup card color */
  --tile-grad-2: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);
  --tile-grad-3: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);
  --tile-grad-4: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);
  --tile-grad-5: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scrollbar-gutter: auto;
  scrollbar-width: none;
}

html::-webkit-scrollbar {
  width: 0;
  height: 0;
}

html::-webkit-scrollbar-track {
  background: transparent;
}

html::-webkit-scrollbar-thumb {
  background: transparent;
}

html::-webkit-scrollbar-thumb:hover {
  background: transparent;
}

html,
body {
  width: 100%;
  min-height: 100%;
  font-size: 72%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
    Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-primary);
  overflow-x: hidden;
  overscroll-behavior-y: none;
}

body {
  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);
  background-attachment: fixed;
  color: var(--text-primary);
  transition:
    background-color var(--transition-normal),
    --bg-primary var(--transition-normal),
    --bg-secondary var(--transition-normal),
    --bg-gradient-end var(--transition-normal),
    --color-primary var(--transition-normal),
    --color-secondary var(--transition-normal),
    --color-accent var(--transition-normal),
    --text-primary var(--transition-normal),
    --text-secondary var(--transition-normal),
    --border-color var(--transition-normal),
    --detail-bg var(--transition-normal);
}

/* Theme overlay for smooth background transitions.
   Deliberately oversized well beyond the viewport in every direction
   (rather than sized to exactly 100%/100vh/100dvh) so it still fully
   covers the screen on mobile devices with rounded/curved corners or a
   notch/dynamic-island cutout, and so it keeps covering the screen when
   the mobile browser's address bar collapses/reveals during scroll. That
   UI change resizes the visual/dynamic viewport (sometimes without firing
   a layout reflow), which can otherwise expose a sliver of unstyled
   background — most visibly right at the curved corners — for an
   exactly-viewport-sized fixed element. Using an oversized fixed element
   sidesteps the resize timing issue entirely instead of trying to track
   the exact viewport size. */
#theme-overlay {
  position: fixed;
  inset: -10vh -10vw;
  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);
  background-size: cover;
  z-index: -1;
  pointer-events: none;
}

/* Fallback background directly on the document root: guarantees there is
   never an unstyled gap (e.g. in the rounded corners of a curved-screen
   device) even for the brief moment before #theme-overlay is present/sized,
   or in browsers that clip fixed-position elements to the safe area. */
html {
  background-color: var(--bg-primary);
  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);
  background-attachment: fixed;
}

.app-container {
  width: 100%;
  min-height: 100vh;
  position: relative;
}

/* ============================================================================
   Layout — fixed sidebar + main content
   ============================================================================ */

.layout {
  display: grid;
  grid-template-columns: var(--sidebar-width) 1fr;
  align-items: start;
  align-content: start;
  min-height: 100vh;
  height: 100vh;
}

.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  padding: var(--spacing-xl) var(--spacing-xl);
  overflow-y: auto;
  border-right: 1px solid var(--border-color);
}

.avatar {
  width: 106px;
  height: 106px;
  border-radius: var(--radius-full);
  overflow: hidden;
}

.avatar-dodecahedron {
  display: block;
  width: 100%;
  height: 100%;
}

.sidebar-name {
  font-size: 2.875rem;
  font-weight: 700;
  margin: 0 0 var(--spacing-md) 0;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
  max-width: 100%;
}

.sidebar-role {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-top: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
  white-space: pre-line;
}

.sidebar-bio {
  font-size: 0.9rem;
  line-height: 1.7;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xl);
}

.sidebar-subheading {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md);
}

.sidebar-links {
  margin-top: var(--spacing-xl);
}

.social-links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.sidebar-link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--text-primary);
  text-decoration: none;
  font-size: 0.85rem;
  line-height: 1rem;
  height: var(--pill-button-height);
  padding: 0 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  transition: color var(--transition-linear), border-color var(--transition-linear), background-color var(--transition-linear), transform var(--transition-hover);
}

.sidebar-link .social-icon {
  fill: currentColor;
  stroke: currentColor;
}

.sidebar-link:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

/* ============================================================================
   Main content — category tabs + gallery grid
   ============================================================================ */

.content {
  padding: 0 var(--spacing-xl) 0 var(--spacing-md);
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  overscroll-behavior-y: contain;
}

.category-nav {
  display: flex;
  flex-wrap: nowrap;
  gap: var(--spacing-sm);
  margin-left: calc(-1 * var(--spacing-xl));
  margin-right: calc(-1 * var(--spacing-xl));
  padding-left: var(--spacing-2xl);
  padding-right: var(--spacing-xl);
  padding-top: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
  border-bottom: 1px solid var(--border-color);
  /* Sticks to the top of the viewport once the page scrolls past it, mirroring
     the sidebar's own sticky behavior so the tabs remain reachable. The
     background repeats the page's own fixed gradient (rather than a blurred
     snapshot of the scrolled content) so the bar reads as a transparent
     "window" onto the page background instead of an opaque panel. Using
     \`background-attachment: fixed\` positions that gradient against the
     viewport — exactly like #theme-overlay — so the two line up seamlessly. */
  position: sticky;
  top: 0;
  z-index: 20;
  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);
  background-attachment: fixed;
  /* Establishes a query context so the tabs can scale their own font-size and
     padding down as this bar's available width shrinks (see .category-tab). */
  container-type: inline-size;
}

.category-tab {
  /* Tabs shrink together (rather than wrapping to a new line) once the
     viewport is too narrow to fit all of them at their natural width. */
  flex: 1 1 0;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-family: inherit;
  /* Font size and horizontal padding scale down with the nav's own width
     (via container query units) so labels shrink to fit rather than being
     truncated with an ellipsis. */
  font-size: clamp(0.7rem, 3.2cqi, 1.05rem);
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1rem;
  height: var(--pill-button-height);
  padding: 0 clamp(0.35rem, 2.4cqi, 1.75rem);
  border-radius: var(--radius-full);
  cursor: pointer;
  /* An inset box-shadow (rather than a real border) draws the ring so the
     active-state gradient background can't leave a hairline gap: a
     border-radius'd \`border\` transitioning to transparent and a
     \`background-clip: border-box\` fill are rasterized as two separate
     anti-aliased paths that don't perfectly coincide at sub-pixel widths,
     letting the page background show through as a thin ring. */
  box-shadow: inset 0 0 0 1.5px var(--border-color);
  transition: color var(--transition-linear), background-color var(--transition-linear), box-shadow var(--transition-linear), font-size var(--transition-linear), padding var(--transition-linear);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.category-tab:hover {
  color: var(--color-primary);
  box-shadow: inset 0 0 0 1.5px var(--color-primary);
}

.category-tab.active {
  box-shadow: none;
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: white;
}

.category-tab:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* category-nav's margin-bottom is fixed (never toggled) so the category-switch
   fade animation never has to reposition the viewport mid-transition, which
   previously caused a jump. Non-photography grids instead add back the extra
   spacing here so their gap below the divider matches the original size,
   while the photography mosaic keeps the tighter default gap. */
.gallery-viewport {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* Establishes a query context so the mosaic below can size its cells as a
     fraction of this element's own width (see .gallery-grid--photo). */
  container-type: inline-size;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.28) transparent;
  scrollbar-gutter: stable both-edges;
}

.gallery-viewport::-webkit-scrollbar {
  width: 8px;
}

.gallery-viewport::-webkit-scrollbar-track {
  background: transparent;
}

.gallery-viewport::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.28);
  border-radius: var(--radius-full);
  border: 2px solid transparent;
  background-clip: padding-box;
}

.gallery-viewport::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.42);
}

.gallery-grid {
  display: grid;
  /* Non-photography galleries use a simple responsive 1/2-column layout
     and cards size to their content height. Photography overrides rows/cols
     below for its mosaic layout. */
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  gap: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  padding-bottom: calc(var(--spacing-2xl) + var(--page-bottom-buffer) + env(safe-area-inset-bottom, 0px));
  will-change: opacity;
}

.gallery-grid--stacked-columns {
  grid-template-columns: 1fr;
}

.gallery-stack-column {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.gallery-grid--stacked-columns .gallery-item {
  width: 100%;
  margin: 0;
}

.gallery-grid--stacked-columns .gallery-item:last-child {
  margin-bottom: 0;
}

@media (min-width: 901px) {
  .gallery-viewport:has(.gallery-grid--stacked-columns) {
    margin-right: calc(-1 * var(--spacing-xl));
    padding-right: calc(var(--spacing-md) + 4px);
  }
}

@container (min-width: 721px) {
  .gallery-grid:not(.gallery-grid--photo):not(.gallery-grid--about) {
    grid-template-columns: repeat(2, 1fr);
  }

  .gallery-grid--stacked-columns {
    align-items: start;
  }
}

@container (max-width: 720px) {
  .gallery-grid--stacked-columns {
    grid-template-columns: 1fr;
  }
}

.gallery-grid--about {
  display: block;
}

.gallery-grid--photo {
  padding-top: 0;
}

/* Blog shares the same non-photo responsive column rules above. */

.about-panel {
  padding: var(--spacing-sm) 0 var(--spacing-xl);
  container-type: inline-size;
}

.about-panel-intro {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--spacing-xl);
  margin-bottom: var(--spacing-xl);
}

.about-panel-photo {
  flex: 0 0 400px;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  margin: 0 auto;
  border-radius: var(--radius-lg);
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
}

.about-panel-text {
  flex: 1 1 320px;
  max-width: 100%;
  min-width: 0;
}

/* Only cap the text column to half the panel's width once the panel is
   actually wide enough for the photo to sit beside it (see .about-panel-intro
   above: photo 400px + text 320px + gap). Below that it's stacked full-width. */
@container (min-width: 753px) {
  .about-panel-text {
    max-width: 50%;
  }
}

.about-panel-text .about-panel-summary {
  margin-bottom: 0;
}

.about-panel-text .about-panel-summary+.about-panel-subheading {
  margin-top: var(--spacing-xl);
}

.about-panel-summary {
  display: flex;
  flex-direction: column;
  gap: var(--about-me-paragraph-gap, 0.85rem);
  font-size: 1.05rem;
  line-height: 1.8;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-xl);
}

.about-panel-summary p {
  margin: 0;
}

.about-panel-subheading {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
  margin-bottom: var(--spacing-md);
}

.about-panel-education-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.about-panel-education-list li {
  display: block;
  font-size: 0.95rem;
  line-height: 1.5;
}

.about-panel-education-degree {
  color: var(--text-secondary);
  font-weight: normal;
  white-space: nowrap;
}

.about-panel-education-institution,
.about-panel-education-period {
  color: var(--text-secondary);
  white-space: nowrap;
}

.about-panel-education-separator {
  color: var(--text-secondary);
  white-space: pre;
}

.about-panel-education-list li:not([data-layout]) .about-panel-education-degree,
.about-panel-education-list li:not([data-layout]) .about-panel-education-institution,
.about-panel-education-list li:not([data-layout]) .about-panel-education-period,
.about-panel-education-list li[data-layout="2-line"] .about-panel-education-degree,
.about-panel-education-list li[data-layout="3-line"] .about-panel-education-degree,
.about-panel-education-list li[data-layout="3-line"] .about-panel-education-institution,
.about-panel-education-list li[data-layout="3-line"] .about-panel-education-period {
  display: block;
}

.about-panel-education-list li:not([data-layout]) .about-panel-education-separator,
.about-panel-education-list li[data-layout="2-line"] .about-panel-education-separator-degree,
.about-panel-education-list li[data-layout="3-line"] .about-panel-education-separator {
  display: none;
}

.about-panel-education-measure {
  position: absolute;
  visibility: hidden;
  white-space: nowrap;
  pointer-events: none;
}

.gallery-item {
  position: relative;
  grid-column: span 1;
  grid-row: span 1;
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  background: transparent;
}

/* Border overlay drawn ABOVE the ::before gradient via higher z-index */
.gallery-item::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: var(--radius-lg);
  box-shadow: inset 0 0 0 1.5px var(--border-color);
  pointer-events: none;
  z-index: 3;
  transition: box-shadow var(--transition-linear);
}

.gallery-item::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: var(--radius-lg);
  pointer-events: none;
  z-index: 0;
  opacity: 0.9;
}

.gallery-item.expanded::before {
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  /* Override inset:0's bottom:0 so height:36px actually constrains the element */
  bottom: auto;
  height: 36px;
}

.gallery-item:hover:not(.expanded) {
  color: var(--text-primary);
}

.gallery-item:hover:not(.expanded)::after {
  box-shadow: inset 0 0 0 1.5px var(--color-primary);
}

.gallery-item.expanded {
  z-index: 2;
}

.gallery-item[data-static="true"] {
  overflow: hidden;
}

.gallery-item[data-static="true"]::before {
  height: 18px;
}

.gallery-item[data-static="true"] .gallery-item-toggle {
  flex-basis: 18px;
}

.gallery-item[data-static="true"] .gallery-item-body {
  flex: 0 0 auto;
  min-height: auto;
  /* position:relative (without a z-index) keeps this box in normal stacking
     order — right above the model mount, since it comes later in the DOM —
     without creating a new stacking context. That matters because a stacking
     context here would become the backdrop root for the details panel's
     backdrop-filter below, cutting it off from the model canvas behind it. */
  position: relative;
}

/* The model mount fills the whole card and sits behind the header/details —
   much larger than the inline 220px mount used by interactive tiles. */
.gallery-item[data-static="true"] .gallery-item-model-mount {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: calc(var(--model-canvas-height-percent, 100) * 1%);
  max-height: 100%;
  margin: 0;
  float: none;
  z-index: 0;
  overflow: hidden;
}

/* \`backdrop-filter\` on the details panel cannot reliably sample a WebGL
   <canvas> painted behind it — most browsers composite WebGL content on its
   own GPU layer, outside of what backdrop-filter can read from. Blurring the
   canvas itself is the robust cross-browser fix; the slight upscale hides
   the softened edge the blur radius would otherwise reveal against the
   tile's clipped bounds. */
.gallery-item[data-static="true"] .model-canvas {
  filter: blur(6px);
  transform: scale(1.1);
}

.gallery-item[data-static="true"] .gallery-item-details {
  flex: 0 0 auto;
  min-height: auto;
  height: auto;
  position: relative;
  background: rgb(from var(--bg-primary) r g b / 0.5);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  font-size: 0.92rem;
}

.gallery-item[data-static="true"] .gallery-item-caption h3 {
  font-size: 0.92rem;
}

.gallery-item[data-static="true"] .gallery-item-caption p {
  font-size: 0.72rem;
}

.gallery-item[data-static="true"] .gallery-item-details h2 {
  font-size: 1.25rem;
}

.gallery-item[data-static="true"] .gallery-item-details h3 {
  font-size: 0.95rem;
}

[data-gradient="1"]::before {
  background: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-primary) 8%, transparent 55%);
}

[data-gradient="2"]::before {
  background: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-secondary) 8%, transparent 55%);
}

[data-gradient="3"]::before {
  background: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-accent) 8%, transparent 55%);
}

[data-gradient="4"]::before {
  background: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-primary) 8%, transparent 55%);
}

[data-gradient="5"]::before {
  background: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-accent) 8%, transparent 55%);
}

.gallery-item-toggle {
  all: unset;
  box-sizing: border-box;
  display: block;
  width: 100%;
  flex: 0 0 100%;
  position: relative;
  cursor: pointer;
  color: white;
  z-index: 1;
  border-radius: var(--radius-lg);
  border-bottom: 1.5px solid transparent;
  border-color: transparent;
  background-image: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  overflow: hidden;
  transition: flex-basis var(--transition-hover), border-radius var(--transition-hover), border-color var(--transition-linear);
}

.gallery-item.expanded .gallery-item-toggle {
  flex-basis: var(--radius-lg);
  border-color: var(--border-color);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.gallery-item-toggle:focus-visible {
  outline: 3px solid var(--color-accent);
  outline-offset: -3px;
}

.gallery-item-media {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition:
    background-color var(--transition-normal);
}

/* Apply gradients based on data-gradient attribute. For tiles with images,
   the image is set via inline style and appears on top. For gradient-only
   tiles, the gradient shows directly. */
.gallery-item-media[data-gradient="1"] {
  background-image: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="2"] {
  background-image: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);
}

.gallery-item-media[data-gradient="3"] {
  background-image: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="4"] {
  background-image: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="5"] {
  background-image: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);
}

/* Apply gradient as a secondary background layer based on data-gradient attribute.
   For tiles with images, the image (set via inline style) appears on top,
   and the gradient serves as a loading placeholder / color base. */
.gallery-item-media[data-gradient="1"]::before,
.gallery-item-media[data-gradient="2"]::before,
.gallery-item-media[data-gradient="3"]::before,
.gallery-item-media[data-gradient="4"]::before,
.gallery-item-media[data-gradient="5"]::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  z-index: -1;
}

.gallery-item-blog .gallery-item-toggle {
  aspect-ratio: 5 / 1;
}

.gallery-item-media[data-gradient="1"]::before {
  background: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="2"]::before {
  background: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);
}

.gallery-item-media[data-gradient="3"]::before {
  background: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="4"]::before {
  background: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);
}

.gallery-item-media[data-gradient="5"]::before {
  background: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);
}

.gallery-item-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: var(--spacing-md);
  padding-top: var(--spacing-2xl);
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
  transition: opacity var(--transition-hover);
}

.gallery-item.expanded .gallery-item-caption {
  opacity: 0;
}

.gallery-item-caption h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
}

.gallery-item-caption a.gallery-item-title-link-caption h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.gallery-item-caption a.gallery-item-title-link-caption {
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  color: white;
  text-decoration: none;
}

.gallery-item-caption a.gallery-item-title-link-caption .gallery-item-title {
  transition: color var(--transition-linear);
}

.gallery-item-caption a.gallery-item-title-link-caption:hover .gallery-item-title {
  color: var(--color-secondary);
}

.gallery-item-caption a.gallery-item-title-link-caption .title-link-arrow {
  opacity: 0.7;
  vertical-align: text-bottom;
  transition: color var(--transition-linear), opacity var(--transition-linear);
}

.gallery-item-caption a.gallery-item-title-link-caption:hover .title-link-arrow {
  color: var(--color-secondary);
  opacity: 1;
}

[data-category="photography"] .gallery-item-caption {
  padding-top: var(--spacing-md);
  background: linear-gradient(to top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 100%);
}

[data-category="photography"] .gallery-item-caption p {
  display: none;
}

.gallery-item-caption p {
  font-size: 0.8rem;
  opacity: 0.9;
}

/* Expanded tile body — sits below the shrunken gradient banner, revealed with a wipe */

.gallery-item-body {
  flex: 0 0 auto;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  clip-path: inset(0 0 100% 0);
  opacity: 0;
  transition: clip-path var(--transition-hover), opacity var(--transition-hover);
}

.gallery-item-body.visible {
  clip-path: inset(0 0 0% 0);
  opacity: 1;
}

.gallery-item-details h2 {
  font-size: 1.4rem;
  color: var(--color-primary);
  margin-bottom: 0.5rem;
  margin-top: 0;
}

.gallery-item-details a.gallery-item-title-link-details h2 {
  font-size: 1.4rem;
  color: var(--color-primary);
  margin: 0;
}

.gallery-item-details a.gallery-item-title-link-details {
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  color: var(--color-primary);
  text-decoration: none;
}

.gallery-item-details a.gallery-item-title-link-details .gallery-item-title {
  transition: color var(--transition-linear);
}

.gallery-item-details a.gallery-item-title-link-details:hover .gallery-item-title {
  color: var(--color-secondary);
}

.gallery-item-details a.gallery-item-title-link-details .title-link-arrow {
  opacity: 0.7;
  vertical-align: text-bottom;
  transition: color var(--transition-linear), opacity var(--transition-linear);
}

.gallery-item-details a.gallery-item-title-link-details:hover .title-link-arrow {
  color: var(--color-secondary);
  opacity: 1;
}

.gallery-item-subtext {
  margin-bottom: var(--spacing-md);
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.gallery-item-model-mount {
  display: block;
  flex: 0 0 auto;
  align-self: stretch;
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  margin: 0;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.gallery-item:not(.has-model) .gallery-item-model-mount {
  display: none;
}

.model-canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.gallery-item-details {
  flex: 0 0 auto;
  overflow: visible;
  padding: var(--spacing-lg) var(--spacing-xl) var(--spacing-xl);
  color: var(--text-primary);
}

.gallery-item-details h3 {
  font-size: 1.05rem;
  margin-top: var(--spacing-lg);
  margin-bottom: var(--spacing-sm);
}

.gallery-item-details p {
  margin-bottom: var(--spacing-md);
  line-height: 1.6;
  color: var(--text-secondary);
}

.gallery-item-details ul,
.gallery-item-details ol {
  margin-left: var(--spacing-lg);
  margin-bottom: var(--spacing-md);
}

.gallery-item-details li {
  margin-bottom: var(--spacing-sm);
  color: var(--text-secondary);
}

.gallery-item-details a:not(.gallery-item-title-link-details) {
  color: var(--color-primary);
  text-decoration: none;
  transition: color var(--transition-linear);
}

.gallery-item-details a:not(.gallery-item-title-link-details):hover {
  color: var(--color-secondary);
  text-decoration: underline;
}

.gallery-item-close {
  position: absolute;
  top: var(--spacing-md);
  right: var(--spacing-md);
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--radius-full);
  border: 2px solid var(--text-secondary);
  padding: 0;
  background-color: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  opacity: 0;
  transition: opacity var(--transition-hover), transform var(--transition-hover), filter var(--transition-hover);
  z-index: 10;
}

.gallery-item-close.visible {
  opacity: 1;
}

.gallery-item-close:hover {
  transform: scale(1.1);
}

.gallery-item-close:active {
  transform: none;
}

/* Theme Toggle */
.theme-toggle {
  position: fixed;
  bottom: var(--spacing-lg);
  left: var(--spacing-lg);
  z-index: 103;
}

.theme-btn {
  width: var(--floating-toggle-size);
  height: var(--floating-toggle-size);
  border-radius: var(--radius-full);
  border: 2px solid var(--text-secondary);
  background-color: transparent;
  color: var(--text-secondary);
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--transition-hover), border-color var(--transition-hover), filter var(--transition-hover);
  backdrop-filter: blur(10px);
}

.theme-btn,
.photo-modal-close,
.blog-modal-close {
  appearance: none;
  -webkit-appearance: none;
  line-height: 0;
  transform-origin: center;
}

.theme-btn svg,
.photo-modal-close svg,
.blog-modal-close svg {
  width: var(--floating-toggle-icon-size, 1.375rem);
  height: var(--floating-toggle-icon-size, 1.375rem);
  display: block;
  flex: 0 0 auto;
  pointer-events: none;
}

.theme-btn:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

/* Mobile category menu toggle — hidden by default, only shown once the
   layout collapses to a single column (see responsive section below), where
   it stands in for the category nav until pressed. */
.mobile-nav-toggle {
  display: none;
  position: fixed;
  bottom: var(--spacing-lg);
  right: var(--spacing-lg);
  z-index: 106;
}

.mobile-nav-btn {
  width: var(--floating-toggle-size);
  height: var(--floating-toggle-size);
}

/* ============================================================================
   Responsive
   ============================================================================ */

@media (max-width: 900px) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    min-height: 100vh;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.28) transparent;
    scrollbar-gutter: stable;
  }

  .layout::-webkit-scrollbar {
    width: 8px;
  }

  .layout::-webkit-scrollbar-track {
    background: transparent;
  }

  .layout::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.28);
    border-radius: var(--radius-full);
    border: 2px solid transparent;
    background-clip: padding-box;
  }

  .layout::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.42);
  }

  .sidebar {
    position: static;
    height: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    border-right: none;
    border-bottom: 1px solid var(--border-color);
    padding: var(--spacing-lg);
  }

  .sidebar-top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacing-sm);
    width: 100%;
  }

  .avatar {
    width: 40px;
    height: 40px;
    margin-bottom: 0;
    margin-top: 0;
    flex-shrink: 0;
  }

  .sidebar-header {
    display: flex;
    align-items: center;
    gap: var(--spacing-md);
    flex: 1 1 0%;
    min-width: 0;
    container-type: inline-size;
  }

  .sidebar-name {
    margin-bottom: 0;
    margin-top: -0.6rem;
    min-width: 0;
    /* Allow wrapping on very narrow viewports instead of clamping font size */
    font-size: clamp(0.98rem, calc((100cqi - 45px - 1rem) * 0.1725), 2.875rem);
    word-break: break-word;
    white-space: normal;
  }

  .sidebar-role,
  .sidebar-bio,
  .sidebar-links {
    flex-basis: 100%;
  }

  .sidebar-role {
    margin-top: var(--spacing-sm);
    margin-bottom: var(--spacing-sm);
  }

  .sidebar-bio {
    margin-bottom: var(--spacing-md);
  }

  .sidebar-links {
    margin-top: 0;
  }

  .content {
    padding: 0 var(--spacing-xl);
    height: auto;
    min-height: 0;
    overflow: visible;
  }

  .gallery-viewport {
    overflow: visible;
    margin-right: 0;
    padding-right: 0;
    padding-top: 0.5em;
  }

  /* .category-nav bleeds full-width by canceling out .content's horizontal
     padding with a matching negative margin (see rule above main media
     query). .content's padding shrinks to --spacing-lg at this breakpoint,
     so the bleed amounts here must match or the nav ends up wider than
     .content — and thus wider than the viewport — causing a horizontal
     scrollbar. */
  .category-nav {
    margin-left: calc(-1 * var(--spacing-lg));
    margin-right: calc(-1 * var(--spacing-lg));
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  /* Below this breakpoint the tab bar is replaced by the floating menu
     button; the nav itself becomes a boxless stack of individually-pilled
     buttons, right edges aligned, that pops up directly above the button
     (anchored to the same corner) rather than a full-width bottom sheet.
     There is no shared panel background — each button blurs the content
     behind only itself (see body.mobile-nav-open .category-tab). Position
     is fixed at all times (open and closed) so toggling never has to flip
     between sticky/fixed — avoiding a flash of the desktop sticky-bar
     placement mid-transition — with only \`opacity\` fading the reveal in
     and out (no movement/scale). */
  .mobile-nav-toggle {
    display: flex;
  }

  .category-nav {
    position: fixed;
    top: auto;
    /* Sits just above the menu button, right edge aligned to it. */
    bottom: calc(var(--spacing-lg) + var(--floating-toggle-size) + var(--spacing-sm));
    left: auto;
    right: var(--spacing-lg);
    width: max-content;
    max-width: calc(100vw - 2 * var(--spacing-lg));
    max-height: 70vh;
    margin: 0;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-end;
    gap: var(--spacing-xs);
    padding: 0;
    border-bottom: none;
    background: none;
    overflow-y: auto;
    overflow-x: visible;
    /* The desktop rule sets \`container-type: inline-size\` so tabs can scale
       via cqi units; that also forces inline-axis size containment, which
       makes an \`auto\` width resolve to 0 instead of shrinking to fit the
       buttons (containment intentionally ignores content when sizing).
       Not needed here since the stacked buttons use a fixed font-size. */
    container-type: normal;
    visibility: hidden;
    transform: translateX(100%);
    pointer-events: none;
    /* Governs the closing animation (the transition value used is always
       read from the *target* state's rule). Reveal is a plain transform
       slide rather than an opacity fade: an ancestor with opacity < 1
       forms an isolated group that suppresses descendant backdrop-filter
       until opacity hits exactly 1, so an opacity fade would keep the
       buttons' blur (see .category-tab:not(.active) below) hidden until
       the final frame. \`visibility\` is held until the slide finishes so
       the menu stays interactive/visible through the close animation. */
    transition: transform 250ms var(--transition-easing), visibility 0s linear 250ms;
    z-index: 105;
  }

  /* Expanded state, toggled via body.mobile-nav-open by the menu button.
     The inactive buttons carry their blur at all times, and the reveal
     avoids opacity entirely, so the blur is live for every frame. */
  body.mobile-nav-open .category-nav {
    visibility: visible;
    transform: translateX(0);
    pointer-events: auto;
    transition: transform 250ms var(--transition-easing), visibility 0s;
  }

  /* Reuses the desktop tab's own look (transparent background, inset ring,
     active gradient) rather than a distinct pill style — see .category-tab
     above for the shared rules. Only sizing (fixed rem values, since the
     cqi-based clamp() relies on the container context disabled above) and
     text alignment differ here. The desktop rule transitions font-size and
     padding (for its own width-based resizing), but those values differ
     between the base rule and this override — inheriting that transition
     here would animate the buttons visibly growing/shrinking every time
     the menu opens or closes, instead of the intended plain fade. */
  .category-tab {
    flex: 0 0 auto;
    width: 100%;
    justify-content: center;
    text-align: center;
    /* Matches .gallery-photo-shuffle-btn's font-size/line-height/padding so
       the mobile category buttons are the same size as the shuffle button. */
    font-size: 0.85rem;
    line-height: 1rem;
    height: var(--pill-button-height);
    padding: 0 1rem;
    transition: color var(--transition-linear), box-shadow var(--transition-linear);
  }

  /* Inactive buttons need their own blurred surface because the mobile menu
     has no shared panel background. The blur is applied at all times so the
     buttons are already softened the moment the nav fades in. */
  .category-tab:not(.active) {
    background-color: rgba(255, 255, 255, 0.04);
    background-color: color-mix(in srgb, var(--bg-primary) 18%, transparent);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
  }
}

@media (max-width: 480px) {
  .gallery-item-details {
    padding: var(--spacing-lg);
  }

  .gallery-item-close {
    width: 1.25rem;
    height: 1.25rem;
    border-width: 1px;
  }

  .gallery-item-close svg {
    width: 60%;
    height: 60%;
  }
}

/* ============================================================================
   Always-expanded tile header (Graphics, Mathematics)
   ============================================================================ */

/* The static header is a <div> that reuses .gallery-item-toggle styles but
   is completely non-interactive. */
.gallery-item-static-header {
  cursor: default;
  pointer-events: none;
  background-image: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
}

/* ============================================================================
   Photography tile — preview: full bleed photo, no caption overlay
   ============================================================================ */

/* Hide caption on preview tiles — the photo speaks for itself */
.gallery-item-photo .gallery-item-caption {
  display: none;
}

/* Photo tiles never expand inline, so suppress the flex-basis transition */
.gallery-item-photo .gallery-item-toggle {
  transition: flex-basis var(--transition-hover), border-radius var(--transition-hover);
}

/* Mosaic grid: N = 6 cells on the long side of every tile (see gallery.ts),
   so 2 landscape tiles side by side = 12 columns. The cell size scales with
   the mosaic's own width (via container query units on .gallery-viewport) so
   there is always room for at least two landscape photos across the row on
   narrow viewports, but is capped so a landscape tile never exceeds 280px —
   on wide pages this lets auto-fill pack more than two landscape photos per
   row instead of stretching them larger.
   JS assigns grid-column/grid-row spans per aspect ratio;
   grid-auto-flow: dense packs tiles to fill gaps greedily. */
.gallery-item-photo {
  grid-column: span 6;
  /* default: landscape */
  grid-row: span 4;
}

.gallery-grid--photo {
  --mosaic-cols: 12;
  --mosaic-gap: var(--spacing-md);
  --mosaic-max-landscape-width: 280px;
  --mosaic-fluid-cell: calc((100cqw - (var(--mosaic-cols) - 1) * var(--mosaic-gap)) / var(--mosaic-cols));
  --mosaic-max-cell: calc((var(--mosaic-max-landscape-width) - 5 * var(--mosaic-gap)) / 6);
  --mosaic-cell: min(var(--mosaic-fluid-cell), var(--mosaic-max-cell));
  display: grid;
  grid-template-columns: repeat(auto-fill, var(--mosaic-cell));
  /* Row 1 is reserved for .gallery-photo-toolbar and sized to its own content,
     so the button never shrinks with --mosaic-cell and overflows upward into
     the category divider above. All further (photo tile) rows fall through
     to grid-auto-rows as before. */
  grid-template-rows: auto;
  grid-auto-rows: var(--mosaic-cell);
  gap: var(--mosaic-gap);
  grid-auto-flow: dense;
}

/* Fallback for browsers without container query unit support */
@supports not (width: 1cqw) {
  .gallery-grid--photo {
    grid-template-columns: repeat(auto-fill, 40px);
    grid-auto-rows: 40px;
  }
}

/* Toolbar row pinned above the mosaic — spans full grid width */
.gallery-photo-toolbar {
  grid-column: 1 / -1;
  grid-row: 1 / span 1;
  padding-top: var(--spacing-md);
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex-wrap: wrap;
}

.gallery-photo-shuffle-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--text-primary);
  background: transparent;
  font-size: 0.85rem;
  /* Fixes the text content's line box to the same height as the shuffle
     icon (16px) so text-only subcategory filter buttons (which share this
     class) come out exactly the same height as the icon+label shuffle
     button, rather than relying on the two differently-sized contents to
     coincidentally match. */
  line-height: 1rem;
  height: var(--pill-button-height);
  padding: 0 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: color var(--transition-linear), border-color var(--transition-linear), background-color var(--transition-linear), transform var(--transition-hover);
}

.gallery-photo-shuffle-btn:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.gallery-photo-shuffle-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.gallery-photo-subcategory-btn.active {
  color: #ffffff;
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.gallery-photo-subcategory-btn.active:hover {
  color: #ffffff;
  opacity: 0.85;
}

.gallery-item-photo-hidden {
  display: none !important;
}

/* ============================================================================
   Photography modal — full-screen overlay with blurred background
   ============================================================================ */

.photo-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-xl);
  background: rgba(0, 0, 0, 0.23);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  opacity: 0;
  transition: opacity 300ms var(--transition-easing);
  cursor: pointer;
  overflow-y: auto;
}

.photo-modal-overlay.visible {
  opacity: 1;
}

/* Close button — same dimensions and feel as .theme-btn, fixed at viewport top-right */
.photo-modal-close {
  position: fixed;
  top: var(--spacing-lg);
  right: var(--spacing-lg);
  width: 3rem;
  height: 3rem;
  border-radius: var(--radius-full);
  border: 2px solid rgba(255, 255, 255, 0.55);
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--transition-linear), border-color var(--transition-linear), filter var(--transition-hover);
  z-index: 201;
}

.photo-modal-close:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.photo-modal-close:focus-visible {
  outline: 2px solid white;
  outline-offset: 3px;
}

.photo-modal-close svg {
  display: block;
}

/* Modal content wrapper — flex column by default (landscape: photo top, info below) */
.photo-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-lg);
  max-width: 88vw;
  max-height: 85vh;
  cursor: default;
}

/* Portrait / square: photo left, info right */
.photo-modal-overlay[data-layout="portrait"] .photo-modal {
  flex-direction: row;
  align-items: flex-start;
  gap: var(--spacing-xl);
}

.photo-modal-overlay[data-layout="portrait"] {
  align-items: flex-start;
  padding-top: calc(var(--spacing-lg) + 3.5rem);
}

/* The photo */
.photo-modal-image {
  display: block;
  border-radius: 0;
  object-fit: contain;
  flex-shrink: 0;
  padding-top: var(--spacing-md);
  max-height: 80vh;
  max-width: 88vw;
  width: auto;
  height: auto;
}

.photo-modal-overlay[data-layout="portrait"] .photo-modal-image {
  max-height: 88vh;
  max-width: 55vw;
}

/* Info panel */
.photo-modal-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  max-width: 88vw;
  width: 100%;
  padding-left: var(--spacing-xs);
  /* Clicking this column's empty space closes the modal, same as the
     backdrop — show the hand cursor to signal that. */
  cursor: pointer;
}

.photo-modal-overlay[data-layout="portrait"] .photo-modal-info {
  flex: 0 0 240px;
  max-width: 240px;
  padding-left: 0;
  padding-top: var(--spacing-xs);
  /* .photo-modal uses align-items: flex-start in portrait, so without this
     the info column's box only wraps its (short) text content — leaving
     empty blurred space below it that belongs to .photo-modal instead of
     .photo-modal-info, which the backdrop click-to-close check doesn't
     match. Stretching makes the whole column clickable. */
  align-self: stretch;
}

.photo-modal-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
  cursor: default;
}

.photo-modal-description {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.65;
  cursor: default;
}

.photo-modal-meta {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
  line-height: 1.5;
  white-space: normal;
  overflow-wrap: break-word;
  cursor: default;
}

/* Portrait: info panel on the right — each field gets its own row */
.photo-modal-overlay[data-layout="portrait"] .photo-meta-item {
  display: block;
}

.photo-modal-overlay[data-layout="portrait"] .photo-meta-sep {
  display: none;
}

/* Mobile: always stack vertically */
@media (max-width: 600px) {
  .photo-modal-overlay {
    padding: var(--spacing-lg);
    align-items: flex-start;
    padding-top: calc(var(--spacing-lg) + 3.5rem);
    overflow-y: auto;
  }

  .photo-modal-overlay[data-layout="portrait"] .photo-modal {
    flex-direction: column;
    align-items: center;
  }

  .photo-modal-image,
  .photo-modal-overlay[data-layout="portrait"] .photo-modal-image {
    max-height: 55vh;
    max-width: 100%;
  }

  .photo-modal-overlay[data-layout="portrait"] .photo-modal-info {
    flex: none;
    max-width: 100%;
  }

  /* Mobile: info is stacked below — allow wrapping instead of truncating */
  .photo-modal-overlay[data-layout="portrait"] .photo-modal-meta {
    white-space: normal;
    overflow-wrap: break-word;
  }

  .photo-modal-overlay[data-layout="portrait"] .photo-meta-item {
    display: inline;
  }

  .photo-modal-overlay[data-layout="portrait"] .photo-meta-sep {
    display: inline;
  }

  .photo-modal-close {
    width: 3rem;
    height: 3rem;
    border-width: 2px;
  }
}

/* ============================================================================
   Blog post modal — same blurred backdrop as the photo modal, with a
   scrollable card containing the rendered Markdown post.
   ============================================================================ */

.blog-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-lg);
  background: rgba(0, 0, 0, 0.23);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  opacity: 0;
  transition: opacity 300ms var(--transition-easing);
  cursor: pointer;
}

.blog-modal-overlay.visible {
  opacity: 1;
}

.blog-modal-close {
  position: absolute;
  top: var(--spacing-md);
  right: var(--spacing-lg);
  width: 3rem;
  height: 3rem;
  border-radius: var(--radius-full);
  border: 2px solid var(--text-secondary);
  background: transparent;
  color: var(--text-secondary);
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color var(--transition-hover), border-color var(--transition-hover), filter var(--transition-hover);
  backdrop-filter: blur(10px);
  z-index: 2;
}

.blog-modal-close:hover {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.blog-modal-close:focus-visible {
  outline: 2px solid white;
  outline-offset: 3px;
}

.blog-modal {
  position: relative;
  cursor: default;
  width: 98vw;
  max-width: 720px;
  height: 96vh;
  overflow: hidden;
  background: var(--bg-primary);
  opacity: 0.85;
  border-radius: var(--radius-lg);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.blog-modal-scroll {
  /* Shared with \`.blog-modal-meta\` and \`.blog-modal-article\` below, which
     both need these to keep the title centered on the close button and the
     gaps above/below the metadata equal. */
  --blog-title-row-h: 3rem;
  --blog-title-font: 1.4rem;
  --blog-date-font: 0.85rem;
  --blog-title-date-gap: 0rem;
  --blog-meta-gap: calc((var(--blog-title-row-h) - var(--blog-title-font)) / 2);
  position: relative;
  width: 100%;
  height: calc(100% - 2 * var(--radius-lg));
  margin: var(--radius-lg) 0;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
}

.blog-modal-scroll::-webkit-scrollbar {
  width: 8px;
  background: transparent;
}

.blog-modal-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: var(--radius-full);
  border: 2px solid transparent;
  background-clip: padding-box;
}

/* Card details (title + date), positioned within the reserved top-padding
   above the markdown article. It's a child of \`.blog-modal-scroll\` (the
   scrolling element itself), so it scrolls away with the rest of the content
   instead of staying pinned in place, while still occupying the existing
   reserved space rather than pushing the markdown down.

   The title row's height matches \`.blog-modal-close\` (--blog-title-row-h)
   and sits flush with the top of the scroll area — which is itself offset
   from the modal edge by \`--radius-lg\`, the same amount the close button is
   offset by \`--spacing-md\` — so centering the title within that row lines
   its center up with the close button's center. \`--blog-meta-gap\` is the
   resulting whitespace above the title glyph; the same value is reused as
   the gap between the metadata and the markdown content below it. */
.blog-modal-meta {
  position: absolute;
  top: 0;
  left: var(--spacing-2xl);
  right: calc(var(--spacing-2xl) + 4rem);
  z-index: 1;
  pointer-events: none;
}

.blog-modal-meta-title-row {
  height: var(--blog-title-row-h);
  display: flex;
  align-items: center;
}

.blog-modal-meta .gallery-item-title {
  font-size: var(--blog-title-font);
  line-height: 1;
  margin: 0;
  color: var(--text-secondary);
}

.blog-modal-meta a {
  pointer-events: auto;
}

.blog-modal-meta-date {
  margin: var(--blog-title-date-gap) 0 0;
  font-size: var(--blog-date-font);
  line-height: 1;
  color: var(--text-secondary);
}

.blog-modal-article {
  width: 100%;
  max-width: 100%;
  padding-top: calc(var(--spacing-md) + var(--blog-title-row-h) + var(--blog-title-date-gap) + var(--blog-date-font) + var(--blog-meta-gap));
  padding-left: var(--spacing-2xl);
  padding-right: var(--spacing-2xl);
  color: var(--text-primary);
  font-size: 0.9rem;
  line-height: 1.7;
}

.blog-modal-loading {
  color: var(--text-secondary);
}

.blog-modal-article h1,
.blog-modal-article h2,
.blog-modal-article h3,
.blog-modal-article h4 {
  color: var(--text-primary);
  line-height: 1.3;
  margin: 1.4em 0 0.6em;
}

.blog-modal-article h1:first-child,
.blog-modal-article h2:first-child,
.blog-modal-article h3:first-child {
  margin-top: 0;
}

.blog-modal-article p {
  margin: 0.8em 0;
}

.blog-modal-article ul,
.blog-modal-article ol {
  margin: 0.8em 0;
  padding-left: 1.4em;
}

.blog-modal-article li {
  margin: 0.3em 0;
}

.blog-modal-article a {
  color: var(--color-primary);
}

.blog-modal-article blockquote {
  margin: 1em 0;
  padding: 0.4em 1em;
  border-left: 3px solid var(--color-primary);
  color: var(--text-secondary);
}

.blog-modal-article code {
  font-family: var(--font-mono, monospace);
  background: rgba(127, 127, 127, 0.15);
  padding: 0.15em 0.4em;
  border-radius: var(--radius-sm, 4px);
  font-size: 0.9em;
}

.blog-modal-article pre {
  background: rgba(127, 127, 127, 0.12);
  padding: var(--spacing-md);
  border-radius: var(--radius-md, 8px);
  overflow-x: auto;
}

.blog-modal-article pre code {
  background: none;
  padding: 0;
}

.blog-modal-article img {
  max-width: 100%;
  border-radius: var(--radius-md, 8px);
}

@media (max-width: 600px) {
  .blog-modal-overlay {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;
  }

  .blog-modal {
    width: 100vw;
    height: 100dvh;
    border-radius: 0;
  }

  .blog-modal-scroll {
    margin: 0;
    height: 100%;
  }

  .blog-modal-meta {
    top: var(--spacing-sm);
    left: var(--spacing-lg);
    right: calc(var(--spacing-lg) + 2.5rem);
  }

  .blog-modal-article {
    padding-left: var(--spacing-lg);
    padding-right: var(--spacing-lg);
  }

  .blog-modal-close {
    top: var(--spacing-md);
    right: var(--spacing-lg);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;;uDAEqD;;EAErD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,WAAW;EACX,mDAAmD;;EAEnD,gBAAgB;EAChB,iDAAiD;EACjD,mDAAmD;EACnD,iDAAiD;EACjD,kDAAkD;EAClD,iCAAiC;;EAEjC,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;;EAErB,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,4CAA4C;;EAE5C;;oBAEkB;EAClB,wGAAwG;EACxG,sBAAsB;EACtB,4GAA4G;EAC5G,wGAAwG;EACxG,2GAA2G;EAC3G,qGAAqG;AACvG;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd;sEACoE;EACpE,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,+FAA+F;EAC/F,4BAA4B;EAC5B,0BAA0B;EAC1B;;;;;;;;;;;wCAWsC;AACxC;;AAEA;;;;;;;;;;;6BAW6B;AAC7B;EACE,eAAe;EACf,kBAAkB;EAClB,+FAA+F;EAC/F,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;;uEAGuE;AACvE;EACE,mCAAmC;EACnC,+FAA+F;EAC/F,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;iFAEiF;;AAEjF;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,iFAAiF;EACjF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,qCAAqC;EACrC,iCAAiC;EACjC,+JAA+J;AACjK;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;iFAEiF;;AAEjF;EACE,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,yCAAyC;EACzC,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,4CAA4C;EAC5C;;;;;;8EAM4E;EAC5E,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,+FAA+F;EAC/F,4BAA4B;EAC5B;8EAC4E;EAC5E,2BAA2B;AAC7B;;AAEA;EACE;wEACsE;EACtE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB;;kCAEgC;EAChC,yCAAyC;EACzC,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,iCAAiC;EACjC,0CAA0C;EAC1C,iCAAiC;EACjC,eAAe;EACf;;;;;+DAK6D;EAC7D,iDAAiD;EACjD,gMAAgM;EAChM,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,iFAAiF;EACjF,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;;gEAIgE;AAChE;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB;uEACqE;EACrE,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb;;mCAEiC;EACjC,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;EACvG,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0CAA0C;IAC1C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;;AAElE;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;;gFAEgF;AAChF;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wEAAwE;AACxE;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,iDAAiD;EACjD,oBAAoB;EACpB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,+EAA+E;EAC/E,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB;;;;6EAI2E;EAC3E,kBAAkB;AACpB;;AAEA;uEACuE;AACvE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0DAA0D;EAC1D,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;2BAK2B;AAC3B;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;EACnD,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kHAAkH;AACpH;;AAEA;EACE,0HAA0H;AAC5H;;AAEA;EACE,iHAAiH;AACnH;;AAEA;EACE,qHAAqH;AACvH;;AAEA;EACE,gHAAgH;AAClH;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;EACzB,+FAA+F;EAC/F,gBAAgB;EAChB,4HAA4H;AAC9H;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B;6CAC2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,2GAA2G;AAC7G;;AAEA;EACE,+GAA+G;AACjH;;AAEA;EACE,2GAA2G;AAC7G;;AAEA;EACE,8GAA8G;AAChH;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;;mEAEmE;AACnE;;;;;EAKE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,yGAAyG;AAC3G;;AAEA;EACE,qGAAqG;AACvG;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;EAC/B,iFAAiF;EACjF,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kFAAkF;AACpF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,uFAAuF;;AAEvF;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,8EAA8E;AAChF;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8DAA8D;EAC9D,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,iCAAiC;EACjC,uCAAuC;EACvC,UAAU;EACV,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,8GAA8G;EAC9G,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,iCAAiC;EACjC,uCAAuC;EACvC,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+GAA+G;EAC/G,2BAA2B;AAC7B;;AAEA;;;EAGE,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;;EAGE,iDAAiD;EACjD,kDAAkD;EAClD,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;qDAEqD;AACrD;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;;iFAEiF;;AAEjF;EACE;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gDAAgD;IAChD,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;EAC9B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,4CAA4C;IAC5C,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,0EAA0E;IAC1E,0EAA0E;IAC1E,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;;;iBAKe;EACf;IACE,yCAAyC;IACzC,0CAA0C;IAC1C,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;;;;;;;;;mCASiC;EACjC;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,+DAA+D;IAC/D,iFAAiF;IACjF,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,8CAA8C;IAC9C,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;IACzB,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;;;;yEAIqE;IACrE,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,oBAAoB;IACpB;;;;;;;wEAOoE;IACpE,gFAAgF;IAChF,YAAY;EACd;;EAEA;;oEAEkE;EAClE;IACE,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,mEAAmE;EACrE;;EAEA;;;;;;;;oEAQkE;EAClE;IACE,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB;6EACyE;IACzE,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,+EAA+E;EACjF;;EAEA;;gEAE8D;EAC9D;IACE,2CAA2C;IAC3C,wEAAwE;IACxE,2BAA2B;IAC3B,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;;iFAEiF;;AAEjF;mCACmC;AACnC;EACE,eAAe;EACf,oBAAoB;EACpB,+FAA+F;AACjG;;AAEA;;iFAEiF;;AAEjF,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;EACE,qFAAqF;AACvF;;AAEA;;;;;;;;6DAQ6D;AAC7D;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mCAAmC;EACnC,uGAAuG;EACvG,wFAAwF;EACxF,oEAAoE;EACpE,aAAa;EACb,4DAA4D;EAC5D;;;mCAGiC;EACjC,wBAAwB;EACxB,kCAAkC;EAClC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE;IACE,8CAA8C;IAC9C,oBAAoB;EACtB;AACF;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB;;;;4BAI0B;EAC1B,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,+JAA+J;AACjK;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iFAEiF;;AAEjF;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,kDAAkD;EAClD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,uFAAuF;AACvF;EACE,eAAe;EACf,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iHAAiH;EACjH,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B;sDACoD;EACpD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B;;;;0DAIwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,6CAA6C;IAC7C,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA,yEAAyE;EACzE;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;;;iFAGiF;;AAEjF;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,uCAAuC;EACvC,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+GAA+G;EAC/G,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE;;2CAEyC;EACzC,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,6EAA6E;EAC7E,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;oEAYoE;AACpE;EACE,kBAAkB;EAClB,MAAM;EACN,wBAAwB;EACxB,sCAAsC;EACtC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0IAA0I;EAC1I,gCAAgC;EAChC,iCAAiC;EACjC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;EAIE,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uCAAuC;EACzC;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;AACF","sourcesContent":["/**\n * Main stylesheet with theme system\n */\n\n@property --bg-primary {\n  syntax: '<color>';\n  initial-value: #d4d0cc;\n  inherits: true;\n}\n\n@property --bg-secondary {\n  syntax: '<color>';\n  initial-value: #585450;\n  inherits: true;\n}\n\n@property --bg-gradient-end {\n  syntax: '<color>';\n  initial-value: #b8a080;\n  inherits: true;\n}\n\n@property --color-primary {\n  syntax: '<color>';\n  initial-value: #006080;\n  inherits: true;\n}\n\n@property --color-secondary {\n  syntax: '<color>';\n  initial-value: #00a0c0;\n  inherits: true;\n}\n\n@property --color-accent {\n  syntax: '<color>';\n  initial-value: #c88040;\n  inherits: true;\n}\n\n@property --text-primary {\n  syntax: '<color>';\n  initial-value: #383430;\n  inherits: true;\n}\n\n@property --text-secondary {\n  syntax: '<color>';\n  initial-value: #585450;\n  inherits: true;\n}\n\n@property --border-color {\n  syntax: '<color>';\n  initial-value: #f8ffff;\n  inherits: true;\n}\n\n@property --detail-bg {\n  syntax: '<color>';\n  initial-value: rgba(255, 255, 255, 0.15);\n  inherits: true;\n}\n\n:root {\n  /* Color properties are set dynamically by ThemeManager — see src/theme.ts.\n     @property declarations above provide initial (light-theme) fallbacks\n     and enable CSS transitions on custom properties. */\n\n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n\n  /* Timing */\n  --transition-easing: cubic-bezier(0.65, 0, 0.35, 1);\n\n  /* Transitions */\n  --transition-fast: 700ms var(--transition-easing);\n  --transition-normal: 700ms var(--transition-easing);\n  --transition-slow: 700ms var(--transition-easing);\n  --transition-hover: 350ms var(--transition-easing);\n  --transition-linear: 350ms linear;\n\n  /* Border radius */\n  --radius-sm: 0.25rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 1rem;\n  --radius-full: 9999px;\n\n  /* Layout */\n  --sidebar-width: 260px;\n  --breakpoint-sidebar: 900px;\n  --pill-button-height: 4.5rem;\n  --floating-toggle-size: 4.5rem;\n  --floating-toggle-icon-size: 2.0625rem;\n  --page-bottom-buffer: clamp(3rem, 5vh, 6rem);\n\n  /* Gallery tile accent gradients — composed from theme colors so they\n     update automatically on theme change, matching the mockup's gradient\n     accent tiles. */\n  --tile-grad-1: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);\n  /* Mockup card color */\n  --tile-grad-2: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);\n  --tile-grad-3: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);\n  --tile-grad-4: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);\n  --tile-grad-5: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scrollbar-gutter: auto;\n  scrollbar-width: none;\n}\n\nhtml::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\nhtml::-webkit-scrollbar-track {\n  background: transparent;\n}\n\nhtml::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\nhtml::-webkit-scrollbar-thumb:hover {\n  background: transparent;\n}\n\nhtml,\nbody {\n  width: 100%;\n  min-height: 100%;\n  font-size: 72%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,\n    Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-primary);\n  overflow-x: hidden;\n  overscroll-behavior-y: none;\n}\n\nbody {\n  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);\n  background-attachment: fixed;\n  color: var(--text-primary);\n  transition:\n    background-color var(--transition-normal),\n    --bg-primary var(--transition-normal),\n    --bg-secondary var(--transition-normal),\n    --bg-gradient-end var(--transition-normal),\n    --color-primary var(--transition-normal),\n    --color-secondary var(--transition-normal),\n    --color-accent var(--transition-normal),\n    --text-primary var(--transition-normal),\n    --text-secondary var(--transition-normal),\n    --border-color var(--transition-normal),\n    --detail-bg var(--transition-normal);\n}\n\n/* Theme overlay for smooth background transitions.\n   Deliberately oversized well beyond the viewport in every direction\n   (rather than sized to exactly 100%/100vh/100dvh) so it still fully\n   covers the screen on mobile devices with rounded/curved corners or a\n   notch/dynamic-island cutout, and so it keeps covering the screen when\n   the mobile browser's address bar collapses/reveals during scroll. That\n   UI change resizes the visual/dynamic viewport (sometimes without firing\n   a layout reflow), which can otherwise expose a sliver of unstyled\n   background — most visibly right at the curved corners — for an\n   exactly-viewport-sized fixed element. Using an oversized fixed element\n   sidesteps the resize timing issue entirely instead of trying to track\n   the exact viewport size. */\n#theme-overlay {\n  position: fixed;\n  inset: -10vh -10vw;\n  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);\n  background-size: cover;\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* Fallback background directly on the document root: guarantees there is\n   never an unstyled gap (e.g. in the rounded corners of a curved-screen\n   device) even for the brief moment before #theme-overlay is present/sized,\n   or in browsers that clip fixed-position elements to the safe area. */\nhtml {\n  background-color: var(--bg-primary);\n  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);\n  background-attachment: fixed;\n}\n\n.app-container {\n  width: 100%;\n  min-height: 100vh;\n  position: relative;\n}\n\n/* ============================================================================\n   Layout — fixed sidebar + main content\n   ============================================================================ */\n\n.layout {\n  display: grid;\n  grid-template-columns: var(--sidebar-width) 1fr;\n  align-items: start;\n  align-content: start;\n  min-height: 100vh;\n  height: 100vh;\n}\n\n.sidebar {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  padding: var(--spacing-xl) var(--spacing-xl);\n  overflow-y: auto;\n  border-right: 1px solid var(--border-color);\n}\n\n.avatar {\n  width: 106px;\n  height: 106px;\n  border-radius: var(--radius-full);\n  overflow: hidden;\n}\n\n.avatar-dodecahedron {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.sidebar-name {\n  font-size: 2.875rem;\n  font-weight: 700;\n  margin: 0 0 var(--spacing-md) 0;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  white-space: normal;\n  word-break: break-word;\n  overflow: visible;\n  text-overflow: clip;\n  max-width: 100%;\n}\n\n.sidebar-role {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  margin-top: var(--spacing-lg);\n  margin-bottom: var(--spacing-lg);\n  white-space: pre-line;\n}\n\n.sidebar-bio {\n  font-size: 0.9rem;\n  line-height: 1.7;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-xl);\n}\n\n.sidebar-subheading {\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-md);\n}\n\n.sidebar-links {\n  margin-top: var(--spacing-xl);\n}\n\n.social-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n}\n\n.sidebar-link {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  color: var(--text-primary);\n  text-decoration: none;\n  font-size: 0.85rem;\n  line-height: 1rem;\n  height: var(--pill-button-height);\n  padding: 0 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  transition: color var(--transition-linear), border-color var(--transition-linear), background-color var(--transition-linear), transform var(--transition-hover);\n}\n\n.sidebar-link .social-icon {\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n.sidebar-link:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n/* ============================================================================\n   Main content — category tabs + gallery grid\n   ============================================================================ */\n\n.content {\n  padding: 0 var(--spacing-xl) 0 var(--spacing-md);\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  overscroll-behavior-y: contain;\n}\n\n.category-nav {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: var(--spacing-sm);\n  margin-left: calc(-1 * var(--spacing-xl));\n  margin-right: calc(-1 * var(--spacing-xl));\n  padding-left: var(--spacing-2xl);\n  padding-right: var(--spacing-xl);\n  padding-top: var(--spacing-lg);\n  padding-bottom: var(--spacing-lg);\n  border-bottom: 1px solid var(--border-color);\n  /* Sticks to the top of the viewport once the page scrolls past it, mirroring\n     the sidebar's own sticky behavior so the tabs remain reachable. The\n     background repeats the page's own fixed gradient (rather than a blurred\n     snapshot of the scrolled content) so the bar reads as a transparent\n     \"window\" onto the page background instead of an opaque panel. Using\n     `background-attachment: fixed` positions that gradient against the\n     viewport — exactly like #theme-overlay — so the two line up seamlessly. */\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  background: linear-gradient(to bottom right, var(--bg-primary) 0%, var(--bg-gradient-end) 100%);\n  background-attachment: fixed;\n  /* Establishes a query context so the tabs can scale their own font-size and\n     padding down as this bar's available width shrinks (see .category-tab). */\n  container-type: inline-size;\n}\n\n.category-tab {\n  /* Tabs shrink together (rather than wrapping to a new line) once the\n     viewport is too narrow to fit all of them at their natural width. */\n  flex: 1 1 0;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  appearance: none;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-family: inherit;\n  /* Font size and horizontal padding scale down with the nav's own width\n     (via container query units) so labels shrink to fit rather than being\n     truncated with an ellipsis. */\n  font-size: clamp(0.7rem, 3.2cqi, 1.05rem);\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 1rem;\n  height: var(--pill-button-height);\n  padding: 0 clamp(0.35rem, 2.4cqi, 1.75rem);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  /* An inset box-shadow (rather than a real border) draws the ring so the\n     active-state gradient background can't leave a hairline gap: a\n     border-radius'd `border` transitioning to transparent and a\n     `background-clip: border-box` fill are rasterized as two separate\n     anti-aliased paths that don't perfectly coincide at sub-pixel widths,\n     letting the page background show through as a thin ring. */\n  box-shadow: inset 0 0 0 1.5px var(--border-color);\n  transition: color var(--transition-linear), background-color var(--transition-linear), box-shadow var(--transition-linear), font-size var(--transition-linear), padding var(--transition-linear);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n\n.category-tab:hover {\n  color: var(--color-primary);\n  box-shadow: inset 0 0 0 1.5px var(--color-primary);\n}\n\n.category-tab.active {\n  box-shadow: none;\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  color: white;\n}\n\n.category-tab:focus-visible {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 2px;\n}\n\n/* category-nav's margin-bottom is fixed (never toggled) so the category-switch\n   fade animation never has to reposition the viewport mid-transition, which\n   previously caused a jump. Non-photography grids instead add back the extra\n   spacing here so their gap below the divider matches the original size,\n   while the photography mosaic keeps the tighter default gap. */\n.gallery-viewport {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* Establishes a query context so the mosaic below can size its cells as a\n     fraction of this element's own width (see .gallery-grid--photo). */\n  container-type: inline-size;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.28) transparent;\n  scrollbar-gutter: stable both-edges;\n}\n\n.gallery-viewport::-webkit-scrollbar {\n  width: 8px;\n}\n\n.gallery-viewport::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.gallery-viewport::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.28);\n  border-radius: var(--radius-full);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.gallery-viewport::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(0, 0, 0, 0.42);\n}\n\n.gallery-grid {\n  display: grid;\n  /* Non-photography galleries use a simple responsive 1/2-column layout\n     and cards size to their content height. Photography overrides rows/cols\n     below for its mosaic layout. */\n  grid-template-columns: 1fr;\n  grid-auto-rows: auto;\n  gap: var(--spacing-lg);\n  padding-top: var(--spacing-lg);\n  padding-bottom: calc(var(--spacing-2xl) + var(--page-bottom-buffer) + env(safe-area-inset-bottom, 0px));\n  will-change: opacity;\n}\n\n.gallery-grid--stacked-columns {\n  grid-template-columns: 1fr;\n}\n\n.gallery-stack-column {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.gallery-grid--stacked-columns .gallery-item {\n  width: 100%;\n  margin: 0;\n}\n\n.gallery-grid--stacked-columns .gallery-item:last-child {\n  margin-bottom: 0;\n}\n\n@media (min-width: 901px) {\n  .gallery-viewport:has(.gallery-grid--stacked-columns) {\n    margin-right: calc(-1 * var(--spacing-xl));\n    padding-right: calc(var(--spacing-md) + 4px);\n  }\n}\n\n@container (min-width: 721px) {\n  .gallery-grid:not(.gallery-grid--photo):not(.gallery-grid--about) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .gallery-grid--stacked-columns {\n    align-items: start;\n  }\n}\n\n@container (max-width: 720px) {\n  .gallery-grid--stacked-columns {\n    grid-template-columns: 1fr;\n  }\n}\n\n.gallery-grid--about {\n  display: block;\n}\n\n.gallery-grid--photo {\n  padding-top: 0;\n}\n\n/* Blog shares the same non-photo responsive column rules above. */\n\n.about-panel {\n  padding: var(--spacing-sm) 0 var(--spacing-xl);\n  container-type: inline-size;\n}\n\n.about-panel-intro {\n  display: flex;\n  flex-direction: row-reverse;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: var(--spacing-xl);\n  margin-bottom: var(--spacing-xl);\n}\n\n.about-panel-photo {\n  flex: 0 0 400px;\n  width: 400px;\n  max-width: 100%;\n  aspect-ratio: 1 / 1;\n  margin: 0 auto;\n  border-radius: var(--radius-lg);\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n}\n\n.about-panel-text {\n  flex: 1 1 320px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n/* Only cap the text column to half the panel's width once the panel is\n   actually wide enough for the photo to sit beside it (see .about-panel-intro\n   above: photo 400px + text 320px + gap). Below that it's stacked full-width. */\n@container (min-width: 753px) {\n  .about-panel-text {\n    max-width: 50%;\n  }\n}\n\n.about-panel-text .about-panel-summary {\n  margin-bottom: 0;\n}\n\n.about-panel-text .about-panel-summary+.about-panel-subheading {\n  margin-top: var(--spacing-xl);\n}\n\n.about-panel-summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--about-me-paragraph-gap, 0.85rem);\n  font-size: 1.05rem;\n  line-height: 1.8;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-xl);\n}\n\n.about-panel-summary p {\n  margin: 0;\n}\n\n.about-panel-subheading {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-secondary);\n  margin-bottom: var(--spacing-md);\n}\n\n.about-panel-education-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.about-panel-education-list li {\n  display: block;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.about-panel-education-degree {\n  color: var(--text-secondary);\n  font-weight: normal;\n  white-space: nowrap;\n}\n\n.about-panel-education-institution,\n.about-panel-education-period {\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.about-panel-education-separator {\n  color: var(--text-secondary);\n  white-space: pre;\n}\n\n.about-panel-education-list li:not([data-layout]) .about-panel-education-degree,\n.about-panel-education-list li:not([data-layout]) .about-panel-education-institution,\n.about-panel-education-list li:not([data-layout]) .about-panel-education-period,\n.about-panel-education-list li[data-layout=\"2-line\"] .about-panel-education-degree,\n.about-panel-education-list li[data-layout=\"3-line\"] .about-panel-education-degree,\n.about-panel-education-list li[data-layout=\"3-line\"] .about-panel-education-institution,\n.about-panel-education-list li[data-layout=\"3-line\"] .about-panel-education-period {\n  display: block;\n}\n\n.about-panel-education-list li:not([data-layout]) .about-panel-education-separator,\n.about-panel-education-list li[data-layout=\"2-line\"] .about-panel-education-separator-degree,\n.about-panel-education-list li[data-layout=\"3-line\"] .about-panel-education-separator {\n  display: none;\n}\n\n.about-panel-education-measure {\n  position: absolute;\n  visibility: hidden;\n  white-space: nowrap;\n  pointer-events: none;\n}\n\n.gallery-item {\n  position: relative;\n  grid-column: span 1;\n  grid-row: span 1;\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n}\n\n/* Border overlay drawn ABOVE the ::before gradient via higher z-index */\n.gallery-item::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: var(--radius-lg);\n  box-shadow: inset 0 0 0 1.5px var(--border-color);\n  pointer-events: none;\n  z-index: 3;\n  transition: box-shadow var(--transition-linear);\n}\n\n.gallery-item::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: var(--radius-lg);\n  pointer-events: none;\n  z-index: 0;\n  opacity: 0.9;\n}\n\n.gallery-item.expanded::before {\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  /* Override inset:0's bottom:0 so height:36px actually constrains the element */\n  bottom: auto;\n  height: 36px;\n}\n\n.gallery-item:hover:not(.expanded) {\n  color: var(--text-primary);\n}\n\n.gallery-item:hover:not(.expanded)::after {\n  box-shadow: inset 0 0 0 1.5px var(--color-primary);\n}\n\n.gallery-item.expanded {\n  z-index: 2;\n}\n\n.gallery-item[data-static=\"true\"] {\n  overflow: hidden;\n}\n\n.gallery-item[data-static=\"true\"]::before {\n  height: 18px;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-toggle {\n  flex-basis: 18px;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-body {\n  flex: 0 0 auto;\n  min-height: auto;\n  /* position:relative (without a z-index) keeps this box in normal stacking\n     order — right above the model mount, since it comes later in the DOM —\n     without creating a new stacking context. That matters because a stacking\n     context here would become the backdrop root for the details panel's\n     backdrop-filter below, cutting it off from the model canvas behind it. */\n  position: relative;\n}\n\n/* The model mount fills the whole card and sits behind the header/details —\n   much larger than the inline 220px mount used by interactive tiles. */\n.gallery-item[data-static=\"true\"] .gallery-item-model-mount {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: calc(var(--model-canvas-height-percent, 100) * 1%);\n  max-height: 100%;\n  margin: 0;\n  float: none;\n  z-index: 0;\n  overflow: hidden;\n}\n\n/* `backdrop-filter` on the details panel cannot reliably sample a WebGL\n   <canvas> painted behind it — most browsers composite WebGL content on its\n   own GPU layer, outside of what backdrop-filter can read from. Blurring the\n   canvas itself is the robust cross-browser fix; the slight upscale hides\n   the softened edge the blur radius would otherwise reveal against the\n   tile's clipped bounds. */\n.gallery-item[data-static=\"true\"] .model-canvas {\n  filter: blur(6px);\n  transform: scale(1.1);\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-details {\n  flex: 0 0 auto;\n  min-height: auto;\n  height: auto;\n  position: relative;\n  background: rgb(from var(--bg-primary) r g b / 0.5);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n  font-size: 0.92rem;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-caption h3 {\n  font-size: 0.92rem;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-caption p {\n  font-size: 0.72rem;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-details h2 {\n  font-size: 1.25rem;\n}\n\n.gallery-item[data-static=\"true\"] .gallery-item-details h3 {\n  font-size: 0.95rem;\n}\n\n[data-gradient=\"1\"]::before {\n  background: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-primary) 8%, transparent 55%);\n}\n\n[data-gradient=\"2\"]::before {\n  background: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-secondary) 8%, transparent 55%);\n}\n\n[data-gradient=\"3\"]::before {\n  background: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-accent) 8%, transparent 55%);\n}\n\n[data-gradient=\"4\"]::before {\n  background: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-primary) 8%, transparent 55%);\n}\n\n[data-gradient=\"5\"]::before {\n  background: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-accent) 8%, transparent 55%);\n}\n\n.gallery-item-toggle {\n  all: unset;\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  flex: 0 0 100%;\n  position: relative;\n  cursor: pointer;\n  color: white;\n  z-index: 1;\n  border-radius: var(--radius-lg);\n  border-bottom: 1.5px solid transparent;\n  border-color: transparent;\n  background-image: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);\n  overflow: hidden;\n  transition: flex-basis var(--transition-hover), border-radius var(--transition-hover), border-color var(--transition-linear);\n}\n\n.gallery-item.expanded .gallery-item-toggle {\n  flex-basis: var(--radius-lg);\n  border-color: var(--border-color);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n}\n\n.gallery-item-toggle:focus-visible {\n  outline: 3px solid var(--color-accent);\n  outline-offset: -3px;\n}\n\n.gallery-item-media {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  transition:\n    background-color var(--transition-normal);\n}\n\n/* Apply gradients based on data-gradient attribute. For tiles with images,\n   the image is set via inline style and appears on top. For gradient-only\n   tiles, the gradient shows directly. */\n.gallery-item-media[data-gradient=\"1\"] {\n  background-image: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"2\"] {\n  background-image: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"3\"] {\n  background-image: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"4\"] {\n  background-image: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"5\"] {\n  background-image: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);\n}\n\n/* Apply gradient as a secondary background layer based on data-gradient attribute.\n   For tiles with images, the image (set via inline style) appears on top,\n   and the gradient serves as a loading placeholder / color base. */\n.gallery-item-media[data-gradient=\"1\"]::before,\n.gallery-item-media[data-gradient=\"2\"]::before,\n.gallery-item-media[data-gradient=\"3\"]::before,\n.gallery-item-media[data-gradient=\"4\"]::before,\n.gallery-item-media[data-gradient=\"5\"]::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.gallery-item-blog .gallery-item-toggle {\n  aspect-ratio: 5 / 1;\n}\n\n.gallery-item-media[data-gradient=\"1\"]::before {\n  background: radial-gradient(circle at top left, var(--color-primary) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"2\"]::before {\n  background: radial-gradient(circle at bottom right, var(--color-secondary) 0%, var(--color-primary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"3\"]::before {\n  background: radial-gradient(circle at top right, var(--color-accent) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"4\"]::before {\n  background: radial-gradient(circle at bottom left, var(--color-primary) 0%, var(--color-secondary) 100%);\n}\n\n.gallery-item-media[data-gradient=\"5\"]::before {\n  background: radial-gradient(circle at top left, var(--color-accent) 0%, var(--color-primary) 100%);\n}\n\n.gallery-item-caption {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: var(--spacing-md);\n  padding-top: var(--spacing-2xl);\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 100%);\n  transition: opacity var(--transition-hover);\n}\n\n.gallery-item.expanded .gallery-item-caption {\n  opacity: 0;\n}\n\n.gallery-item-caption h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.2rem;\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3em;\n  color: white;\n  text-decoration: none;\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption .gallery-item-title {\n  transition: color var(--transition-linear);\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption:hover .gallery-item-title {\n  color: var(--color-secondary);\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption .title-link-arrow {\n  opacity: 0.7;\n  vertical-align: text-bottom;\n  transition: color var(--transition-linear), opacity var(--transition-linear);\n}\n\n.gallery-item-caption a.gallery-item-title-link-caption:hover .title-link-arrow {\n  color: var(--color-secondary);\n  opacity: 1;\n}\n\n[data-category=\"photography\"] .gallery-item-caption {\n  padding-top: var(--spacing-md);\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0) 100%);\n}\n\n[data-category=\"photography\"] .gallery-item-caption p {\n  display: none;\n}\n\n.gallery-item-caption p {\n  font-size: 0.8rem;\n  opacity: 0.9;\n}\n\n/* Expanded tile body — sits below the shrunken gradient banner, revealed with a wipe */\n\n.gallery-item-body {\n  flex: 0 0 auto;\n  width: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  clip-path: inset(0 0 100% 0);\n  opacity: 0;\n  transition: clip-path var(--transition-hover), opacity var(--transition-hover);\n}\n\n.gallery-item-body.visible {\n  clip-path: inset(0 0 0% 0);\n  opacity: 1;\n}\n\n.gallery-item-details h2 {\n  font-size: 1.4rem;\n  color: var(--color-primary);\n  margin-bottom: 0.5rem;\n  margin-top: 0;\n}\n\n.gallery-item-details a.gallery-item-title-link-details h2 {\n  font-size: 1.4rem;\n  color: var(--color-primary);\n  margin: 0;\n}\n\n.gallery-item-details a.gallery-item-title-link-details {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3em;\n  color: var(--color-primary);\n  text-decoration: none;\n}\n\n.gallery-item-details a.gallery-item-title-link-details .gallery-item-title {\n  transition: color var(--transition-linear);\n}\n\n.gallery-item-details a.gallery-item-title-link-details:hover .gallery-item-title {\n  color: var(--color-secondary);\n}\n\n.gallery-item-details a.gallery-item-title-link-details .title-link-arrow {\n  opacity: 0.7;\n  vertical-align: text-bottom;\n  transition: color var(--transition-linear), opacity var(--transition-linear);\n}\n\n.gallery-item-details a.gallery-item-title-link-details:hover .title-link-arrow {\n  color: var(--color-secondary);\n  opacity: 1;\n}\n\n.gallery-item-subtext {\n  margin-bottom: var(--spacing-md);\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n}\n\n.gallery-item-model-mount {\n  display: block;\n  flex: 0 0 auto;\n  align-self: stretch;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1;\n  margin: 0;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n\n.gallery-item:not(.has-model) .gallery-item-model-mount {\n  display: none;\n}\n\n.model-canvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.gallery-item-details {\n  flex: 0 0 auto;\n  overflow: visible;\n  padding: var(--spacing-lg) var(--spacing-xl) var(--spacing-xl);\n  color: var(--text-primary);\n}\n\n.gallery-item-details h3 {\n  font-size: 1.05rem;\n  margin-top: var(--spacing-lg);\n  margin-bottom: var(--spacing-sm);\n}\n\n.gallery-item-details p {\n  margin-bottom: var(--spacing-md);\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n.gallery-item-details ul,\n.gallery-item-details ol {\n  margin-left: var(--spacing-lg);\n  margin-bottom: var(--spacing-md);\n}\n\n.gallery-item-details li {\n  margin-bottom: var(--spacing-sm);\n  color: var(--text-secondary);\n}\n\n.gallery-item-details a:not(.gallery-item-title-link-details) {\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: color var(--transition-linear);\n}\n\n.gallery-item-details a:not(.gallery-item-title-link-details):hover {\n  color: var(--color-secondary);\n  text-decoration: underline;\n}\n\n.gallery-item-close {\n  position: absolute;\n  top: var(--spacing-md);\n  right: var(--spacing-md);\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--text-secondary);\n  padding: 0;\n  background-color: transparent;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n  opacity: 0;\n  transition: opacity var(--transition-hover), transform var(--transition-hover), filter var(--transition-hover);\n  z-index: 10;\n}\n\n.gallery-item-close.visible {\n  opacity: 1;\n}\n\n.gallery-item-close:hover {\n  transform: scale(1.1);\n}\n\n.gallery-item-close:active {\n  transform: none;\n}\n\n/* Theme Toggle */\n.theme-toggle {\n  position: fixed;\n  bottom: var(--spacing-lg);\n  left: var(--spacing-lg);\n  z-index: 103;\n}\n\n.theme-btn {\n  width: var(--floating-toggle-size);\n  height: var(--floating-toggle-size);\n  border-radius: var(--radius-full);\n  border: 2px solid var(--text-secondary);\n  background-color: transparent;\n  color: var(--text-secondary);\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color var(--transition-hover), border-color var(--transition-hover), filter var(--transition-hover);\n  backdrop-filter: blur(10px);\n}\n\n.theme-btn,\n.photo-modal-close,\n.blog-modal-close {\n  appearance: none;\n  -webkit-appearance: none;\n  line-height: 0;\n  transform-origin: center;\n}\n\n.theme-btn svg,\n.photo-modal-close svg,\n.blog-modal-close svg {\n  width: var(--floating-toggle-icon-size, 1.375rem);\n  height: var(--floating-toggle-icon-size, 1.375rem);\n  display: block;\n  flex: 0 0 auto;\n  pointer-events: none;\n}\n\n.theme-btn:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n/* Mobile category menu toggle — hidden by default, only shown once the\n   layout collapses to a single column (see responsive section below), where\n   it stands in for the category nav until pressed. */\n.mobile-nav-toggle {\n  display: none;\n  position: fixed;\n  bottom: var(--spacing-lg);\n  right: var(--spacing-lg);\n  z-index: 106;\n}\n\n.mobile-nav-btn {\n  width: var(--floating-toggle-size);\n  height: var(--floating-toggle-size);\n}\n\n/* ============================================================================\n   Responsive\n   ============================================================================ */\n\n@media (max-width: 900px) {\n  .layout {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    min-height: 100vh;\n    height: 100vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(0, 0, 0, 0.28) transparent;\n    scrollbar-gutter: stable;\n  }\n\n  .layout::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  .layout::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .layout::-webkit-scrollbar-thumb {\n    background-color: rgba(0, 0, 0, 0.28);\n    border-radius: var(--radius-full);\n    border: 2px solid transparent;\n    background-clip: padding-box;\n  }\n\n  .layout::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(0, 0, 0, 0.42);\n  }\n\n  .sidebar {\n    position: static;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    border-right: none;\n    border-bottom: 1px solid var(--border-color);\n    padding: var(--spacing-lg);\n  }\n\n  .sidebar-top {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: var(--spacing-sm);\n    width: 100%;\n  }\n\n  .avatar {\n    width: 40px;\n    height: 40px;\n    margin-bottom: 0;\n    margin-top: 0;\n    flex-shrink: 0;\n  }\n\n  .sidebar-header {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-md);\n    flex: 1 1 0%;\n    min-width: 0;\n    container-type: inline-size;\n  }\n\n  .sidebar-name {\n    margin-bottom: 0;\n    margin-top: -0.6rem;\n    min-width: 0;\n    /* Allow wrapping on very narrow viewports instead of clamping font size */\n    font-size: clamp(0.98rem, calc((100cqi - 45px - 1rem) * 0.1725), 2.875rem);\n    word-break: break-word;\n    white-space: normal;\n  }\n\n  .sidebar-role,\n  .sidebar-bio,\n  .sidebar-links {\n    flex-basis: 100%;\n  }\n\n  .sidebar-role {\n    margin-top: var(--spacing-sm);\n    margin-bottom: var(--spacing-sm);\n  }\n\n  .sidebar-bio {\n    margin-bottom: var(--spacing-md);\n  }\n\n  .sidebar-links {\n    margin-top: 0;\n  }\n\n  .content {\n    padding: 0 var(--spacing-xl);\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n\n  .gallery-viewport {\n    overflow: visible;\n    margin-right: 0;\n    padding-right: 0;\n    padding-top: 0.5em;\n  }\n\n  /* .category-nav bleeds full-width by canceling out .content's horizontal\n     padding with a matching negative margin (see rule above main media\n     query). .content's padding shrinks to --spacing-lg at this breakpoint,\n     so the bleed amounts here must match or the nav ends up wider than\n     .content — and thus wider than the viewport — causing a horizontal\n     scrollbar. */\n  .category-nav {\n    margin-left: calc(-1 * var(--spacing-lg));\n    margin-right: calc(-1 * var(--spacing-lg));\n    padding-left: var(--spacing-lg);\n    padding-right: var(--spacing-lg);\n  }\n\n  /* Below this breakpoint the tab bar is replaced by the floating menu\n     button; the nav itself becomes a boxless stack of individually-pilled\n     buttons, right edges aligned, that pops up directly above the button\n     (anchored to the same corner) rather than a full-width bottom sheet.\n     There is no shared panel background — each button blurs the content\n     behind only itself (see body.mobile-nav-open .category-tab). Position\n     is fixed at all times (open and closed) so toggling never has to flip\n     between sticky/fixed — avoiding a flash of the desktop sticky-bar\n     placement mid-transition — with only `opacity` fading the reveal in\n     and out (no movement/scale). */\n  .mobile-nav-toggle {\n    display: flex;\n  }\n\n  .category-nav {\n    position: fixed;\n    top: auto;\n    /* Sits just above the menu button, right edge aligned to it. */\n    bottom: calc(var(--spacing-lg) + var(--floating-toggle-size) + var(--spacing-sm));\n    left: auto;\n    right: var(--spacing-lg);\n    width: max-content;\n    max-width: calc(100vw - 2 * var(--spacing-lg));\n    max-height: 70vh;\n    margin: 0;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-end;\n    gap: var(--spacing-xs);\n    padding: 0;\n    border-bottom: none;\n    background: none;\n    overflow-y: auto;\n    overflow-x: visible;\n    /* The desktop rule sets `container-type: inline-size` so tabs can scale\n       via cqi units; that also forces inline-axis size containment, which\n       makes an `auto` width resolve to 0 instead of shrinking to fit the\n       buttons (containment intentionally ignores content when sizing).\n       Not needed here since the stacked buttons use a fixed font-size. */\n    container-type: normal;\n    visibility: hidden;\n    transform: translateX(100%);\n    pointer-events: none;\n    /* Governs the closing animation (the transition value used is always\n       read from the *target* state's rule). Reveal is a plain transform\n       slide rather than an opacity fade: an ancestor with opacity < 1\n       forms an isolated group that suppresses descendant backdrop-filter\n       until opacity hits exactly 1, so an opacity fade would keep the\n       buttons' blur (see .category-tab:not(.active) below) hidden until\n       the final frame. `visibility` is held until the slide finishes so\n       the menu stays interactive/visible through the close animation. */\n    transition: transform 250ms var(--transition-easing), visibility 0s linear 250ms;\n    z-index: 105;\n  }\n\n  /* Expanded state, toggled via body.mobile-nav-open by the menu button.\n     The inactive buttons carry their blur at all times, and the reveal\n     avoids opacity entirely, so the blur is live for every frame. */\n  body.mobile-nav-open .category-nav {\n    visibility: visible;\n    transform: translateX(0);\n    pointer-events: auto;\n    transition: transform 250ms var(--transition-easing), visibility 0s;\n  }\n\n  /* Reuses the desktop tab's own look (transparent background, inset ring,\n     active gradient) rather than a distinct pill style — see .category-tab\n     above for the shared rules. Only sizing (fixed rem values, since the\n     cqi-based clamp() relies on the container context disabled above) and\n     text alignment differ here. The desktop rule transitions font-size and\n     padding (for its own width-based resizing), but those values differ\n     between the base rule and this override — inheriting that transition\n     here would animate the buttons visibly growing/shrinking every time\n     the menu opens or closes, instead of the intended plain fade. */\n  .category-tab {\n    flex: 0 0 auto;\n    width: 100%;\n    justify-content: center;\n    text-align: center;\n    /* Matches .gallery-photo-shuffle-btn's font-size/line-height/padding so\n       the mobile category buttons are the same size as the shuffle button. */\n    font-size: 0.85rem;\n    line-height: 1rem;\n    height: var(--pill-button-height);\n    padding: 0 1rem;\n    transition: color var(--transition-linear), box-shadow var(--transition-linear);\n  }\n\n  /* Inactive buttons need their own blurred surface because the mobile menu\n     has no shared panel background. The blur is applied at all times so the\n     buttons are already softened the moment the nav fades in. */\n  .category-tab:not(.active) {\n    background-color: rgba(255, 255, 255, 0.04);\n    background-color: color-mix(in srgb, var(--bg-primary) 18%, transparent);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n  }\n}\n\n@media (max-width: 480px) {\n  .gallery-item-details {\n    padding: var(--spacing-lg);\n  }\n\n  .gallery-item-close {\n    width: 1.25rem;\n    height: 1.25rem;\n    border-width: 1px;\n  }\n\n  .gallery-item-close svg {\n    width: 60%;\n    height: 60%;\n  }\n}\n\n/* ============================================================================\n   Always-expanded tile header (Graphics, Mathematics)\n   ============================================================================ */\n\n/* The static header is a <div> that reuses .gallery-item-toggle styles but\n   is completely non-interactive. */\n.gallery-item-static-header {\n  cursor: default;\n  pointer-events: none;\n  background-image: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);\n}\n\n/* ============================================================================\n   Photography tile — preview: full bleed photo, no caption overlay\n   ============================================================================ */\n\n/* Hide caption on preview tiles — the photo speaks for itself */\n.gallery-item-photo .gallery-item-caption {\n  display: none;\n}\n\n/* Photo tiles never expand inline, so suppress the flex-basis transition */\n.gallery-item-photo .gallery-item-toggle {\n  transition: flex-basis var(--transition-hover), border-radius var(--transition-hover);\n}\n\n/* Mosaic grid: N = 6 cells on the long side of every tile (see gallery.ts),\n   so 2 landscape tiles side by side = 12 columns. The cell size scales with\n   the mosaic's own width (via container query units on .gallery-viewport) so\n   there is always room for at least two landscape photos across the row on\n   narrow viewports, but is capped so a landscape tile never exceeds 280px —\n   on wide pages this lets auto-fill pack more than two landscape photos per\n   row instead of stretching them larger.\n   JS assigns grid-column/grid-row spans per aspect ratio;\n   grid-auto-flow: dense packs tiles to fill gaps greedily. */\n.gallery-item-photo {\n  grid-column: span 6;\n  /* default: landscape */\n  grid-row: span 4;\n}\n\n.gallery-grid--photo {\n  --mosaic-cols: 12;\n  --mosaic-gap: var(--spacing-md);\n  --mosaic-max-landscape-width: 280px;\n  --mosaic-fluid-cell: calc((100cqw - (var(--mosaic-cols) - 1) * var(--mosaic-gap)) / var(--mosaic-cols));\n  --mosaic-max-cell: calc((var(--mosaic-max-landscape-width) - 5 * var(--mosaic-gap)) / 6);\n  --mosaic-cell: min(var(--mosaic-fluid-cell), var(--mosaic-max-cell));\n  display: grid;\n  grid-template-columns: repeat(auto-fill, var(--mosaic-cell));\n  /* Row 1 is reserved for .gallery-photo-toolbar and sized to its own content,\n     so the button never shrinks with --mosaic-cell and overflows upward into\n     the category divider above. All further (photo tile) rows fall through\n     to grid-auto-rows as before. */\n  grid-template-rows: auto;\n  grid-auto-rows: var(--mosaic-cell);\n  gap: var(--mosaic-gap);\n  grid-auto-flow: dense;\n}\n\n/* Fallback for browsers without container query unit support */\n@supports not (width: 1cqw) {\n  .gallery-grid--photo {\n    grid-template-columns: repeat(auto-fill, 40px);\n    grid-auto-rows: 40px;\n  }\n}\n\n/* Toolbar row pinned above the mosaic — spans full grid width */\n.gallery-photo-toolbar {\n  grid-column: 1 / -1;\n  grid-row: 1 / span 1;\n  padding-top: var(--spacing-md);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  flex-wrap: wrap;\n}\n\n.gallery-photo-shuffle-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  color: var(--text-primary);\n  background: transparent;\n  font-size: 0.85rem;\n  /* Fixes the text content's line box to the same height as the shuffle\n     icon (16px) so text-only subcategory filter buttons (which share this\n     class) come out exactly the same height as the icon+label shuffle\n     button, rather than relying on the two differently-sized contents to\n     coincidentally match. */\n  line-height: 1rem;\n  height: var(--pill-button-height);\n  padding: 0 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: color var(--transition-linear), border-color var(--transition-linear), background-color var(--transition-linear), transform var(--transition-hover);\n}\n\n.gallery-photo-shuffle-btn:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.gallery-photo-shuffle-btn:focus-visible {\n  outline: 2px solid var(--color-accent);\n  outline-offset: 2px;\n}\n\n.gallery-photo-subcategory-btn.active {\n  color: #ffffff;\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.gallery-photo-subcategory-btn.active:hover {\n  color: #ffffff;\n  opacity: 0.85;\n}\n\n.gallery-item-photo-hidden {\n  display: none !important;\n}\n\n/* ============================================================================\n   Photography modal — full-screen overlay with blurred background\n   ============================================================================ */\n\n.photo-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-xl);\n  background: rgba(0, 0, 0, 0.23);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  opacity: 0;\n  transition: opacity 300ms var(--transition-easing);\n  cursor: pointer;\n  overflow-y: auto;\n}\n\n.photo-modal-overlay.visible {\n  opacity: 1;\n}\n\n/* Close button — same dimensions and feel as .theme-btn, fixed at viewport top-right */\n.photo-modal-close {\n  position: fixed;\n  top: var(--spacing-lg);\n  right: var(--spacing-lg);\n  width: 3rem;\n  height: 3rem;\n  border-radius: var(--radius-full);\n  border: 2px solid rgba(255, 255, 255, 0.55);\n  background: transparent;\n  color: rgba(255, 255, 255, 0.85);\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color var(--transition-linear), border-color var(--transition-linear), filter var(--transition-hover);\n  z-index: 201;\n}\n\n.photo-modal-close:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.photo-modal-close:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 3px;\n}\n\n.photo-modal-close svg {\n  display: block;\n}\n\n/* Modal content wrapper — flex column by default (landscape: photo top, info below) */\n.photo-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-lg);\n  max-width: 88vw;\n  max-height: 85vh;\n  cursor: default;\n}\n\n/* Portrait / square: photo left, info right */\n.photo-modal-overlay[data-layout=\"portrait\"] .photo-modal {\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--spacing-xl);\n}\n\n.photo-modal-overlay[data-layout=\"portrait\"] {\n  align-items: flex-start;\n  padding-top: calc(var(--spacing-lg) + 3.5rem);\n}\n\n/* The photo */\n.photo-modal-image {\n  display: block;\n  border-radius: 0;\n  object-fit: contain;\n  flex-shrink: 0;\n  padding-top: var(--spacing-md);\n  max-height: 80vh;\n  max-width: 88vw;\n  width: auto;\n  height: auto;\n}\n\n.photo-modal-overlay[data-layout=\"portrait\"] .photo-modal-image {\n  max-height: 88vh;\n  max-width: 55vw;\n}\n\n/* Info panel */\n.photo-modal-info {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  max-width: 88vw;\n  width: 100%;\n  padding-left: var(--spacing-xs);\n  /* Clicking this column's empty space closes the modal, same as the\n     backdrop — show the hand cursor to signal that. */\n  cursor: pointer;\n}\n\n.photo-modal-overlay[data-layout=\"portrait\"] .photo-modal-info {\n  flex: 0 0 240px;\n  max-width: 240px;\n  padding-left: 0;\n  padding-top: var(--spacing-xs);\n  /* .photo-modal uses align-items: flex-start in portrait, so without this\n     the info column's box only wraps its (short) text content — leaving\n     empty blurred space below it that belongs to .photo-modal instead of\n     .photo-modal-info, which the backdrop click-to-close check doesn't\n     match. Stretching makes the whole column clickable. */\n  align-self: stretch;\n}\n\n.photo-modal-title {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.95);\n  margin: 0;\n  cursor: default;\n}\n\n.photo-modal-description {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.75);\n  margin: 0;\n  line-height: 1.65;\n  cursor: default;\n}\n\n.photo-modal-meta {\n  font-size: 0.78rem;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n  line-height: 1.5;\n  white-space: normal;\n  overflow-wrap: break-word;\n  cursor: default;\n}\n\n/* Portrait: info panel on the right — each field gets its own row */\n.photo-modal-overlay[data-layout=\"portrait\"] .photo-meta-item {\n  display: block;\n}\n\n.photo-modal-overlay[data-layout=\"portrait\"] .photo-meta-sep {\n  display: none;\n}\n\n/* Mobile: always stack vertically */\n@media (max-width: 600px) {\n  .photo-modal-overlay {\n    padding: var(--spacing-lg);\n    align-items: flex-start;\n    padding-top: calc(var(--spacing-lg) + 3.5rem);\n    overflow-y: auto;\n  }\n\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-modal {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .photo-modal-image,\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-modal-image {\n    max-height: 55vh;\n    max-width: 100%;\n  }\n\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-modal-info {\n    flex: none;\n    max-width: 100%;\n  }\n\n  /* Mobile: info is stacked below — allow wrapping instead of truncating */\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-modal-meta {\n    white-space: normal;\n    overflow-wrap: break-word;\n  }\n\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-meta-item {\n    display: inline;\n  }\n\n  .photo-modal-overlay[data-layout=\"portrait\"] .photo-meta-sep {\n    display: inline;\n  }\n\n  .photo-modal-close {\n    width: 3rem;\n    height: 3rem;\n    border-width: 2px;\n  }\n}\n\n/* ============================================================================\n   Blog post modal — same blurred backdrop as the photo modal, with a\n   scrollable card containing the rendered Markdown post.\n   ============================================================================ */\n\n.blog-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-lg);\n  background: rgba(0, 0, 0, 0.23);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  opacity: 0;\n  transition: opacity 300ms var(--transition-easing);\n  cursor: pointer;\n}\n\n.blog-modal-overlay.visible {\n  opacity: 1;\n}\n\n.blog-modal-close {\n  position: absolute;\n  top: var(--spacing-md);\n  right: var(--spacing-lg);\n  width: 3rem;\n  height: 3rem;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--text-secondary);\n  background: transparent;\n  color: var(--text-secondary);\n  padding: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color var(--transition-hover), border-color var(--transition-hover), filter var(--transition-hover);\n  backdrop-filter: blur(10px);\n  z-index: 2;\n}\n\n.blog-modal-close:hover {\n  color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.blog-modal-close:focus-visible {\n  outline: 2px solid white;\n  outline-offset: 3px;\n}\n\n.blog-modal {\n  position: relative;\n  cursor: default;\n  width: 98vw;\n  max-width: 720px;\n  height: 96vh;\n  overflow: hidden;\n  background: var(--bg-primary);\n  opacity: 0.85;\n  border-radius: var(--radius-lg);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.blog-modal-scroll {\n  /* Shared with `.blog-modal-meta` and `.blog-modal-article` below, which\n     both need these to keep the title centered on the close button and the\n     gaps above/below the metadata equal. */\n  --blog-title-row-h: 3rem;\n  --blog-title-font: 1.4rem;\n  --blog-date-font: 0.85rem;\n  --blog-title-date-gap: 0rem;\n  --blog-meta-gap: calc((var(--blog-title-row-h) - var(--blog-title-font)) / 2);\n  position: relative;\n  width: 100%;\n  height: calc(100% - 2 * var(--radius-lg));\n  margin: var(--radius-lg) 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.25) transparent;\n}\n\n.blog-modal-scroll::-webkit-scrollbar {\n  width: 8px;\n  background: transparent;\n}\n\n.blog-modal-scroll::-webkit-scrollbar-thumb {\n  background-color: rgba(0, 0, 0, 0.25);\n  border-radius: var(--radius-full);\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n/* Card details (title + date), positioned within the reserved top-padding\n   above the markdown article. It's a child of `.blog-modal-scroll` (the\n   scrolling element itself), so it scrolls away with the rest of the content\n   instead of staying pinned in place, while still occupying the existing\n   reserved space rather than pushing the markdown down.\n\n   The title row's height matches `.blog-modal-close` (--blog-title-row-h)\n   and sits flush with the top of the scroll area — which is itself offset\n   from the modal edge by `--radius-lg`, the same amount the close button is\n   offset by `--spacing-md` — so centering the title within that row lines\n   its center up with the close button's center. `--blog-meta-gap` is the\n   resulting whitespace above the title glyph; the same value is reused as\n   the gap between the metadata and the markdown content below it. */\n.blog-modal-meta {\n  position: absolute;\n  top: 0;\n  left: var(--spacing-2xl);\n  right: calc(var(--spacing-2xl) + 4rem);\n  z-index: 1;\n  pointer-events: none;\n}\n\n.blog-modal-meta-title-row {\n  height: var(--blog-title-row-h);\n  display: flex;\n  align-items: center;\n}\n\n.blog-modal-meta .gallery-item-title {\n  font-size: var(--blog-title-font);\n  line-height: 1;\n  margin: 0;\n  color: var(--text-secondary);\n}\n\n.blog-modal-meta a {\n  pointer-events: auto;\n}\n\n.blog-modal-meta-date {\n  margin: var(--blog-title-date-gap) 0 0;\n  font-size: var(--blog-date-font);\n  line-height: 1;\n  color: var(--text-secondary);\n}\n\n.blog-modal-article {\n  width: 100%;\n  max-width: 100%;\n  padding-top: calc(var(--spacing-md) + var(--blog-title-row-h) + var(--blog-title-date-gap) + var(--blog-date-font) + var(--blog-meta-gap));\n  padding-left: var(--spacing-2xl);\n  padding-right: var(--spacing-2xl);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  line-height: 1.7;\n}\n\n.blog-modal-loading {\n  color: var(--text-secondary);\n}\n\n.blog-modal-article h1,\n.blog-modal-article h2,\n.blog-modal-article h3,\n.blog-modal-article h4 {\n  color: var(--text-primary);\n  line-height: 1.3;\n  margin: 1.4em 0 0.6em;\n}\n\n.blog-modal-article h1:first-child,\n.blog-modal-article h2:first-child,\n.blog-modal-article h3:first-child {\n  margin-top: 0;\n}\n\n.blog-modal-article p {\n  margin: 0.8em 0;\n}\n\n.blog-modal-article ul,\n.blog-modal-article ol {\n  margin: 0.8em 0;\n  padding-left: 1.4em;\n}\n\n.blog-modal-article li {\n  margin: 0.3em 0;\n}\n\n.blog-modal-article a {\n  color: var(--color-primary);\n}\n\n.blog-modal-article blockquote {\n  margin: 1em 0;\n  padding: 0.4em 1em;\n  border-left: 3px solid var(--color-primary);\n  color: var(--text-secondary);\n}\n\n.blog-modal-article code {\n  font-family: var(--font-mono, monospace);\n  background: rgba(127, 127, 127, 0.15);\n  padding: 0.15em 0.4em;\n  border-radius: var(--radius-sm, 4px);\n  font-size: 0.9em;\n}\n\n.blog-modal-article pre {\n  background: rgba(127, 127, 127, 0.12);\n  padding: var(--spacing-md);\n  border-radius: var(--radius-md, 8px);\n  overflow-x: auto;\n}\n\n.blog-modal-article pre code {\n  background: none;\n  padding: 0;\n}\n\n.blog-modal-article img {\n  max-width: 100%;\n  border-radius: var(--radius-md, 8px);\n}\n\n@media (max-width: 600px) {\n  .blog-modal-overlay {\n    padding: 0;\n    align-items: stretch;\n    justify-content: stretch;\n  }\n\n  .blog-modal {\n    width: 100vw;\n    height: 100dvh;\n    border-radius: 0;\n  }\n\n  .blog-modal-scroll {\n    margin: 0;\n    height: 100%;\n  }\n\n  .blog-modal-meta {\n    top: var(--spacing-sm);\n    left: var(--spacing-lg);\n    right: calc(var(--spacing-lg) + 2.5rem);\n  }\n\n  .blog-modal-article {\n    padding-left: var(--spacing-lg);\n    padding-right: var(--spacing-lg);\n  }\n\n  .blog-modal-close {\n    top: var(--spacing-md);\n    right: var(--spacing-lg);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
